function onClickOutside(event, el, handler) {
    const isClickOutside = event.target !== el && !el.contains(event.target);
    if (!isClickOutside)
        return null;
    return handler(event, el);
}
const instances = new Map();
function toggleEventListeners(handler) {
    return (action) => {
        document[`${action}EventListener`]('click', handler, true);
    };
}
function bind(el, binding) {
    const eventHandler = (event) => onClickOutside(event, el, binding.value);
    toggleEventListeners(eventHandler)('add');
    instances.set(el, eventHandler);
}
function unbind(el) {
    const eventHandler = instances.get(el);
    toggleEventListeners(eventHandler)('remove');
    instances.delete(el);
}
const directive = {
    bind,
    unbind,
};
export default directive;
